// extracted by mini-css-extract-plugin
module.exports = {"layout":"Authenticated_layout__49QDD"};